import React from "react";

export default function Footer() {
    return (<footer className="footer">
        <div className="container">
            <div className="d-flex flex-column gap-5 flex-md-row footer__row justify-content-between">
                <div className="d-flex flex-column gap-5 order-0">
                    <div className="d-flex flex-column gap-5">
                        <div className="d-flex flex-column gap-3">
                            <a href="tel:+74956642177" className="bs-link fs-4 font-2">+7 (495) 664-21-77</a>
                            <p>Москва</p>
                        </div>
                        <div className="d-flex flex-column gap-3">
                            <a href="tel:88005051834" className="bs-link fs-4 font-2">8-800-505-18-34</a>
                            <p>Россия</p>
                        </div>
                    </div>
                    <div className="d-flex flex-column gap-3 mt-2">
                        <a href="mailto:pride@pride.ru" className="fw-bold bs-link fs-4">pride@pride.ru</a>
                        <p>
                            Пн – Пт
                            <br/>08:00 – 17:00
                        </p>
                    </div>
                    <div className="footer__info">
                        <p>ООО «Торговый Дом ПРАЙД»</p>
                        <p>Почтовый адрес: 125438, г. Москва, ул. Автомоторная, д.8</p>
                        <p>ИНН 7743139407</p>
                        <p>КПП 774301001</p>
                        <p>ОГРН 1167746148393</p>
                    </div>
                    <p>© Прайд, 2002-2025</p>
                </div>
                <div className="d-flex flex-column gap-5 order-2 order-md-1">
                    <div className="d-flex justify-content-between gap-5 flex-md-column justify-content-sm-start">
                        <div className="d-flex flex-column gap-3">
                            <a href="#" className="bs-link">Личный кабинет</a>
                            <a href="#" className="bs-link">Каталог</a>
                            <a href="#" className="bs-link">Где купить?</a>
                            <a href="#" className="bs-link">Контакты</a>
                        </div>
                        <div className="d-flex flex-column gap-3">
                            <a href="#" className="bs-link">Доставка и оплата</a>
                            <a href="#" className="bs-link">Обмен и возврат</a>
                            <a href="#" className="bs-link">Гарантия</a>
                        </div>
                    </div>
                    <div className="d-flex flex-column gap-2 mt-auto">
                        <a href="#" className="link-min">Политика конфиденциальности</a>
                        <a href="#" className="link-min">Пользовательское соглашение</a>
                    </div>
                </div>
                <div className="d-flex flex-column gap-3 order-1 order-md-1">
                    <p className="font-2 fw-medium">Офис</p>
                    <a href="#" className="bs-link">ул. Автомоторная, д.8</a>
                    <a href="mailto:moscow@pride.ru" className="bs-link">moscow@pride.ru</a>
                    <a href="tel:+79999999999" className="bs-link">+7 (495) 664-21-77</a>
                    <p>
                        Пн – Пт
                        <br/>08:00 – 17:00
                    </p>
                    <div className="connect__social">
                        <a className="d-flex align-items-center justify-content-center" href="https://vk.com/prideth">
                            <img className="w-100" src="/images/vk.svg" alt="VK"/>
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </footer>)
}